var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.labelShow_),expression:"labelShow_"}],ref:"coordinateLabel",staticClass:"sd-coordinate clickable no-select round-corner",attrs:{"id":'coordinate-label-' + _vm.type},on:{"click":_vm.handleShowViewInfo}},[_c('div',{ref:" lastLabel"},[_vm._v(_vm._s(_vm.lastLabel_))])])
}
var staticRenderFns = []

export { render, staticRenderFns }